const items = [
  "BRANDING",
  "PERFORMANCE",
  "STORYTELLING",
  "SEO",
  "PAID SOCIAL",
  "CONTENT",
  "ANALYTICS",
  "GROWTH",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="border-y border-zinc-200 py-8 md:py-12 overflow-hidden bg-[#f4f4f5]"
    >
      <div className="sv-marquee-track sv-marquee-track-slow">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center shrink-0">
            {items.map((it, idx) => (
              <span
                key={`${i}-${idx}`}
                className="font-display font-black uppercase text-6xl md:text-8xl lg:text-9xl tracking-tighter mx-8 stroke-text whitespace-nowrap"
              >
                {it}
                <span className="text-[#002FA7] mx-6">●</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
